<map-options></map-options>

<map-search-panel></map-search-panel>

<learning-map></learning-map>
